import { defaultAgent, apiResponse } from '../helpers/web-agent';
import { toastError, toastSuccess } from './toast';
import { tokenExpired } from './auth';
import { getSearchDateRange } from '../helpers/common';
import {
    HARDWARE_GET_DEVICE_LIST, UNASSIGN_CANCODE_SUCCESS, GET_DEVICE_COMMAND_LIST_REQUEST, GET_DEVICE_COMMAND_LIST,
    SEND_DEVICE_COMMAND_REQUEST, SEND_DEVICE_COMMAND_RESPONSE, HARDWARE_GET_DEVICE_LIST_REQUEST, GET_LATEST_SENSOR_LIST_REQUEST,
    GET_LATEST_SENSOR_LIST, CLEAR_SEND_DEVICE_COMMAND, GET_HARDWARE_LIST_REQUEST, GET_HARDWARE_LIST,
    GET_HARDWARE_ACTIVITY_LIST_REQUEST, GET_HARDWARE_ACTIVITY_LIST, GET_GPS_SENSOR_DATA_REQUEST, GET_GPS_SENSOR_DATA,
    GET_QAPP_LOGS_REQUEST, GET_QAPP_LOGS, GET_BOARD_LIST_REQUEST, GET_BOARD_LIST, GET_HARDWARE_TYPE, GET_HARDWARE_TYPE_REQUEST, UPDATE_HARDWARE_LIST
} from '../constants/action-types';
import { RECORD_FOUND, UNASSIGN_CANCODE } from '../constants/messages';
import { parseSensorList } from '../interceptors/hardware';

export const getDeviceListRequest = () => ({ type: HARDWARE_GET_DEVICE_LIST_REQUEST });

export const deviceList = payload => ({ type: HARDWARE_GET_DEVICE_LIST, payload });

export const unassignCancodeSuccess = payload => ({ type: UNASSIGN_CANCODE_SUCCESS, payload });

export const getDeviceCommandListRequest = () => ({ type: GET_DEVICE_COMMAND_LIST_REQUEST });

export const deviceCommandList = (data) => ({ type: GET_DEVICE_COMMAND_LIST, payload: data });

export const sendDeviceCommandRequest = (data) => ({ type: SEND_DEVICE_COMMAND_REQUEST, payload: data });

export const sendDeviceCommandResponse = (deviceId, error, success, response) => ({ type: SEND_DEVICE_COMMAND_RESPONSE, payload: { deviceId, error, success, response } });

export const clearSendDeviceCommand = (deviceId) => ({ type: CLEAR_SEND_DEVICE_COMMAND, deviceId });

export const getLatestSensorListRequest = () => ({ type: GET_LATEST_SENSOR_LIST_REQUEST });

export const latestSensorList = data => ({ type: GET_LATEST_SENSOR_LIST, payload: data });

export const getHardwareListRequest = () => ({ type: GET_HARDWARE_LIST_REQUEST });

export const hardwareList = payload => ({ type: GET_HARDWARE_LIST, payload });

export const updateHardwareList = payload => ({ type: UPDATE_HARDWARE_LIST, payload });

export const getHardwareActivityListRequest = (hardwareId) => ({ type: GET_HARDWARE_ACTIVITY_LIST_REQUEST, hardwareId });

export const hardwareActivityList = (hardwareId, payload) => ({ type: GET_HARDWARE_ACTIVITY_LIST, hardwareId, payload });

export const getGPSSensorListRequest = (hardwareId) => ({ type: GET_GPS_SENSOR_DATA_REQUEST, hardwareId });

export const gpsSensorList = (hardwareId, payload) => ({ type: GET_GPS_SENSOR_DATA, hardwareId, payload });

export const qappLogListRequest = (hardwareId) => ({ type: GET_QAPP_LOGS_REQUEST, hardwareId });

export const qappLogList = (hardwareId, payload) => ({ type: GET_QAPP_LOGS, hardwareId, payload });

export const boardListRequest = () => ({ type: GET_BOARD_LIST_REQUEST });

export const boardList = (data) => ({ type: GET_BOARD_LIST, payload: data });

export const hardwareTypeRequest = () => ({ type: GET_HARDWARE_TYPE_REQUEST });

export const hardwareType = (data) => ({ type: GET_HARDWARE_TYPE, payload: data });

export const unassignCancode = (data, cb) => dispatch => {
    const params = {
        farm_uuid: data.farmId,
        device_uuid: data.deviceId,
        device_name: data.deviceName
    };

    defaultAgent.put('/api/qapp/unassigncancode', params, { requestId: `hardware_unassign_${data.deviceId}` })
        .then(res => {
            const agentResult = apiResponse(res, []);
            if (agentResult.isUnauthorized) {
                dispatch(toastError(agentResult.message));
                dispatch(tokenExpired());
            } else if (agentResult.code === UNASSIGN_CANCODE.code) {
                dispatch(unassignCancodeSuccess(data));
                if (cb) cb();
            }
            else if (agentResult.message) {
                dispatch(toastError(agentResult.message));
                if (cb) cb(agentResult.message);
            }
        }).catch(ex => {
            if (defaultAgent.isCancel(ex)) return console.log('Unassign can code: ', ex.message);
            if (cb) cb(ex.message);
            dispatch(toastError(ex.message));
        });
};

export const getDeviceList = (farmId, cb) => (dispatch, getState) => {
    dispatch(getDeviceListRequest());
    const search = getState().analyze.searchParams;
    const dateInfo = getSearchDateRange(search);

    const params = {
        farm_uuid: farmId,
        from_date: dateInfo.from,
        to_date: dateInfo.to,
        deviceList: 1
    };

    defaultAgent.get('api/device/hardware/list', params, { requestId: `hardware_eglist` })
        .then(res => {
            const agentResult = apiResponse(res, []);
            if (agentResult.isUnauthorized) {
                dispatch(toastError(agentResult.message));
                dispatch(tokenExpired());
            } else if (agentResult.message) {
                dispatch(toastError(agentResult.message));
                dispatch(deviceList());
            } else if (agentResult.data) {
                dispatch(deviceList(agentResult.data));
                if (cb) cb(agentResult.data);
            }
        }).catch(ex => {
            if (defaultAgent.isCancel(ex)) return console.log('Hardware EG List: ', ex.message);
            dispatch(toastError(ex.message));
            dispatch(deviceList());
        });
};

export const getLatestSensorList = egList => dispatch => {
    dispatch(getLatestSensorListRequest());

    const egIds = egList.map(e => e.equipment_group_uuid);
    const params = {
        equipment_group_uuid: egIds.join(','),
        sensor: 'can_interface_health,battery_level,battery_charging_state,battery_temperature,gps,can_connection,q_connection',
    };

    defaultAgent.post('/api/equipment/group/sensor/latest', params, { requestId: `hardware_sensor` })
        .then(res => {
            const agentResult = apiResponse(res, {});
            if (agentResult.isUnauthorized) {
                dispatch(toastError(agentResult.message));
                return dispatch(tokenExpired());
            } else if (agentResult.message) {
                dispatch(toastError(agentResult.message));
            } else if (agentResult.data) {
                const list = parseSensorList(egList, agentResult.data);
                dispatch(latestSensorList(list));
            }
        }).catch(ex => {
            if (defaultAgent.isCancel(ex)) return console.log('Hardware Sensor: ', ex.message);
            dispatch(latestSensorList({}));
            dispatch(toastError(ex.message));
        });
};

export const getGPSSensorList = (hardwareId, egIds) => dispatch => {
    dispatch(getGPSSensorListRequest(hardwareId));

    const params = {
        equipment_group_uuid: egIds.join(','),
        sensor: 'gps',
        start_date: "2010-01-01T00:00:00Z",
        end_date: "3000-01-01T00:00:00Z"
    };

    defaultAgent.post('/api/equipment/group/sensor/data', params, { requestId: `hardware_sensor_gps` })
        .then(res => {
            const agentResult = apiResponse(res, {});
            if (agentResult.isUnauthorized) {
                dispatch(toastError(agentResult.message));
                return dispatch(tokenExpired());
            } else if (agentResult.message) {
                dispatch(toastError(agentResult.message));
            } else if (agentResult.data) {
                dispatch(gpsSensorList(hardwareId, agentResult.data));
            }
        }).catch(ex => {
            if (defaultAgent.isCancel(ex)) return console.log('Hardware Sensor GPS: ', ex.message);
            dispatch(gpsSensorList(hardwareId));
            dispatch(toastError(ex.message));
        });
};

export const getDeviceCommandList = () => dispatch => {
    dispatch(getDeviceCommandListRequest());

    defaultAgent.get('api/device/command/list')
        .then(res => {
            const agentResult = apiResponse(res, []);
            if (agentResult.isUnauthorized) {
                dispatch(toastError(agentResult.message));
                dispatch(tokenExpired());
            } else if (agentResult.message) {
                dispatch(toastError(agentResult.message));
                dispatch(deviceCommandList([]));
            } else if (agentResult.data) {
                dispatch(deviceCommandList(agentResult.data))
            }
        }).catch(ex => {
            dispatch(toastError(ex.message));
            dispatch(deviceCommandList([]));
        });
};

export const sendDeviceCommand = (params) => dispatch => {
    dispatch(sendDeviceCommandRequest(params));
    const reqParams = { ...params, parameter: params.parameter ? params.parameter : {} };

    defaultAgent.post('api/device/command/send', reqParams)
        .then(res => {
            const agentResult = apiResponse(res, {});
            if (agentResult.isUnauthorized) {
                dispatch(toastError(agentResult.message));
                dispatch(tokenExpired());
                dispatch(sendDeviceCommandResponse(params.device_uuid));
            } else if (agentResult.code === RECORD_FOUND.code && agentResult.data
                && agentResult.data.result === "success") {
                dispatch(sendDeviceCommandResponse(params.device_uuid, null, "command sent.", agentResult.data));
            } else {
                dispatch(sendDeviceCommandResponse(params.device_uuid, "command send failed."));
            }
        }).catch(() => {
            dispatch(sendDeviceCommandResponse(params.device_uuid, "command timeout."));
        });
};

export const getHardwareList = (cb = null) => dispatch => {
    dispatch(getHardwareListRequest());

    defaultAgent.get('api/device/hardware/list')
        .then(res => {
            const agentResult = apiResponse(res, []);
            if (agentResult.isUnauthorized) {
                dispatch(toastError(agentResult.message));
                dispatch(tokenExpired());
            } else if (agentResult.message) {
                dispatch(toastError(agentResult.message));
                dispatch(hardwareList([]));
            } else if (agentResult.data) {
                dispatch(hardwareList(agentResult.data))
                if (cb) cb(agentResult.data);
            }
        }).catch(ex => {
            dispatch(toastError(ex.message));
            dispatch(hardwareList([]));
        });
};

export const getHardwareActivityList = (reqParams) => dispatch => {
    dispatch(getHardwareActivityListRequest(reqParams.hardware_uuid));

    defaultAgent.get('api/device/hardware/activity', reqParams)
        .then(res => {
            const agentResult = apiResponse(res, []);
            if (agentResult.isUnauthorized) {
                dispatch(toastError(agentResult.message));
                dispatch(tokenExpired());
            } else if (agentResult.message) {
                dispatch(toastError(agentResult.message));
                dispatch(hardwareActivityList(reqParams.hardware_uuid, []));
            } else if (agentResult.data) {
                dispatch(hardwareActivityList(reqParams.hardware_uuid, agentResult.data))
            }
        }).catch(ex => {
            dispatch(toastError(ex.message));
            dispatch(hardwareActivityList(reqParams.hardware_uuid, []));
        });
};

export const getQAppLogList = (hardwareId, reqParams) => dispatch => {
    dispatch(qappLogListRequest(hardwareId));

    defaultAgent.post('api/qapp/logs', reqParams)
        .then(res => {
            const agentResult = apiResponse(res, []);
            if (agentResult.isUnauthorized) {
                dispatch(toastError(agentResult.message));
                dispatch(tokenExpired());
            } else if (agentResult.message) {
                dispatch(toastError(agentResult.message));
                dispatch(qappLogList(hardwareId, []));
            } else if (agentResult.data) {
                dispatch(qappLogList(hardwareId, agentResult.data))
            }
        }).catch(ex => {
            dispatch(toastError(ex.message));
            dispatch(qappLogList(hardwareId, []));
        });
};

export const getBoardList = () => dispatch => {
    dispatch(boardListRequest());
    defaultAgent.get('api/device/hardware/board/list').then(res => {
        const agentResult = apiResponse(res, []);
        if (agentResult.isUnauthorized) {
            dispatch(toastError(agentResult.message));
            dispatch(tokenExpired());
        } else if (agentResult.data)
            dispatch(boardList(agentResult.data));
        else if (agentResult.message)
            dispatch(toastError(agentResult.message));
    }).catch(ex => {
        dispatch(toastError(ex.message));
    });
};

export const bulkAssignFarm = (params, cb) => dispatch => {
    defaultAgent.post('api/device/hardware/assignfarm', params)
        .then(res => {
            const agentResult = apiResponse(res, []);
            if (agentResult.isUnauthorized) {
                dispatch(toastError(agentResult.message));
                dispatch(tokenExpired());
            } else if (agentResult.code === 8007) {
                dispatch(toastSuccess(agentResult.message));
                if (cb) cb();
            } else if (agentResult.message) {
                dispatch(toastError(agentResult.message));
            }
        }).catch(ex => {
            dispatch(toastError(ex.message));
        });
};

export const getHardwareType = () => dispatch => {
    dispatch(hardwareTypeRequest());
    defaultAgent.get('api/hardware/type')
        .then(res => {
            const agentResult = apiResponse(res, []);
            if (agentResult.isUnauthorized) {
                dispatch(toastError(agentResult.message));
                dispatch(tokenExpired());
            } else if (agentResult.data)
                dispatch(hardwareType(agentResult.data));
            else if (agentResult.message)
                dispatch(toastError(agentResult.message));
        }).catch(ex => {
            dispatch(toastError(ex.message));
        });
};

export const archiveDevice = (params, cb) => dispatch => {
    defaultAgent.post('api/device/hardware/archive', params)
        .then(res => {
            const agentResult = apiResponse(res, []);
            if (agentResult.isUnauthorized) {
                dispatch(toastError(agentResult.message));
                dispatch(tokenExpired());
            } else if (agentResult.code === 1009) {
                dispatch(toastSuccess(agentResult.message));
                if (cb) cb();
            } else if (agentResult.message) {
                dispatch(toastError(agentResult.message));
            }
        }).catch(ex => {
            dispatch(toastError(ex.message));
        });
};

export const unArchiveDevice = (params, cb) => dispatch => {
    defaultAgent.post('api/device/hardware/un-archive', params)
        .then(res => {
            const agentResult = apiResponse(res, []);
            if (agentResult.isUnauthorized) {
                dispatch(toastError(agentResult.message));
                dispatch(tokenExpired());
            } else if (agentResult.code === 1009) {
                dispatch(toastSuccess(agentResult.message));
                if (cb) cb();
            } else if (agentResult.message) {
                dispatch(toastError(agentResult.message));
            }
        }).catch(ex => {
            dispatch(toastError(ex.message));
        });
};